import BaseUseCase from "../../base_use_case.js";
class CreateMessageUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/support/messages`,
      data: this.wrapParams(params, "message")
    });
  }
}

const instance = new CreateMessageUseCase();
export default instance;